<template>
  <section>
    <b-collapse
      :open="false"
      class="card"
      animation="slide"
      aria-id="examples">
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="examples">
          <p class="card-header-title">
            Examples
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
            </b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content">
          <p>Version published 02/27/23</p>
          <p>Click an example to copy it to your clipboard.</p>
            <input class="example" readonly=true v-for="ex in examples"
              :key="ex" :name="ex"
              v-on:click="copyQuery" :value="ex"/>
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>

import exampleText from '@/assets/test_examples.txt';

export default {
  props: {
    open: Boolean,
  },
  data() {
    return {
      examples: exampleText.split('\n'),
    };
  },
  methods: {
    copyQuery(e) {
      e.target.select();
      document.execCommand('copy');
    },
  },
};
</script>

<style scoped>
.card {
  margin: 15px;
  margin-top: 20px;
}
.card-content {
  height: 220px;
  overflow: auto;
}
.example {
  width: 100%;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
